/* LP header: announcement rotation, sticky header, drawers, predictive search, AJAX cart drawer. */
(function () {
  'use strict';
  if (window.__lpHeaderLoaded) return;
  window.__lpHeaderLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents, currency) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- Announcement ---------- */
  function initAnnouncement(el) {
    var msgs = el.querySelectorAll('.lp-ann__msg');
    if (msgs.length < 2) return;
    var i = 0, timer;
    function show(n) {
      msgs[i].classList.remove('is-active');
      msgs[i].classList.add('is-leaving');
      var old = msgs[i];
      setTimeout(function () { old.classList.remove('is-leaving'); }, 400);
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active');
    }
    function start() { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, +el.dataset.speed || 5000); }
    var prev = el.querySelector('[data-lp-ann-prev]'), next = el.querySelector('[data-lp-ann-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    el.addEventListener('mouseenter', function () { clearInterval(timer); });
    el.addEventListener('mouseleave', start);
    start();
  }

  /* ---------- Sticky header ---------- */
  function initSticky(wrap) {
    var mode = wrap.dataset.sticky;
    var sec = wrap.closest('.lp-header-section') || wrap.parentElement;
    if (mode === 'none') return;
    sec.classList.add('is-sticky');
    var last = window.scrollY;
    /* Product page: header hidden from the start (more room for photo + offers), slides in when the user scrolls back up */
    if (document.body.classList.contains('lp-tpl-product')) {
      var root = document.documentElement;
      sec.classList.add('is-reveal');
      root.classList.add('lp-hdr-hidden');
      window.addEventListener('scroll', function () {
        var y = window.scrollY, d = y - last;
        if (Math.abs(d) < 6) return;                  /* ignore tiny jitters */
        var show = (d < 0 && y > 40) || root.classList.contains('lp-locked');
        sec.classList.toggle('is-revealed', show);
        sec.classList.toggle('is-scrolled', show);
        root.classList.toggle('lp-hdr-hidden', !show);
        last = y;
      }, { passive: true });
      return;
    }
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      sec.classList.toggle('is-scrolled', y > 10);
      if (mode === 'scroll-up') {
        var hide = y > last && y > sec.offsetHeight + 80 && !document.documentElement.classList.contains('lp-locked');
        sec.style.top = hide ? -sec.offsetHeight + 'px' : '0px';
        document.documentElement.classList.toggle('lp-hdr-hidden', hide);
      }
      last = y;
    }, { passive: true });
  }

  /* ---------- Panels (menu / search / cart) ---------- */
  var openPanel = null, lastFocus = null;
  function open(name) {
    var p = document.querySelector('[data-lp-panel="' + name + '"]');
    if (!p) return false;
    if (openPanel && openPanel !== p) close();
    lastFocus = document.activeElement;
    p.classList.add('is-open');
    p.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lp-locked');
    document.querySelectorAll('[data-lp-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    openPanel = p;
    var focusTarget = p.querySelector('[data-lp-search-input]') || p.querySelector('[data-lp-close]:not(.lp-drawer__overlay)');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
    if (name === 'cart') Cart.refresh();
    return true;
  }
  function close() {
    if (!openPanel) return;
    var name = openPanel.dataset.lpPanel;
    openPanel.classList.remove('is-open');
    openPanel.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lp-locked');
    document.querySelectorAll('[data-lp-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openPanel = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lp-open]');
    if (opener && open(opener.dataset.lpOpen)) { e.preventDefault(); return; }
    if (e.target.closest('[data-lp-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab' && openPanel) { // keep focus inside the open panel
      var f = openPanel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), summary');
      f = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------- Predictive search ---------- */
  function initSearch(input) {
    var results = document.querySelector('[data-lp-search-results]');
    var t, ctrl;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { results.innerHTML = '<p class="lp-search__empty">No results for “' + esc(q) + '”</p>'; return; }
            results.innerHTML = '<ul>' + items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              return '<li><a class="lp-search__item" href="' + esc(p.url) + '"><img src="' + esc(sized(img, 120)) + '" alt="" loading="lazy"><span>' + esc(p.title) + '<small>$' + esc(p.price) + '</small></span></a></li>';
            }).join('') + '</ul><a class="lp-search__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '">See all results →</a>';
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    el: null,
    busy: false,
    get: function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); },
    refresh: function () { return Cart.get().then(Cart.render).catch(function () {}); },
    add: function (items) {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
    },
    change: function (key, qty) {
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(Cart.render);
    },
    open: function () { if (!open('cart')) window.location.href = root + 'cart'; },
    afterAdd: function () {
      return Cart.refresh().then(function () { Cart.open(); bump(); });
    },
    render: function (cart) {
      var el = Cart.el;
      document.querySelectorAll('[data-lp-cart-count]').forEach(function (c) {
        c.textContent = cart.item_count;
        c.hidden = cart.item_count === 0;
      });
      document.querySelectorAll('[data-lp-open="cart"]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items'); });
      if (!el) return cart;
      var cur = el.dataset.currency || cart.currency;
      el.querySelector('[data-lp-cart-heading-count]').textContent = '(' + cart.item_count + ')';

      var list = el.querySelector('[data-lp-cart-items]');
      list.innerHTML = cart.items.map(function (it) {
        var discounted = it.final_line_price < it.original_line_price;
        var discs = (it.line_level_discount_allocations || []).map(function (d) {
          return '<span class="lp-line__disc">🏷 ' + esc(d.discount_application.title) + ' (−' + money(d.amount, cur) + ')</span>';
        }).join('');
        return '<li class="lp-line" data-key="' + esc(it.key) + '">' +
          '<a class="lp-line__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 160)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="lp-line__info">' +
            '<a class="lp-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            (it.product_has_only_default_variant ? '' : '<span class="lp-line__variant">' + esc(it.variant_title) + '</span>') +
            (it.selling_plan_allocation ? '<span class="lp-line__plan">🔁 ' + esc(it.selling_plan_allocation.selling_plan.name) + '</span>' : '') +
            discs +
            '<div class="lp-qty"><button type="button" data-lp-line-qty="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-lp-line-qty="1" aria-label="Increase quantity">+</button></div>' +
          '</div>' +
          '<div class="lp-line__right"><span>' + (discounted ? '<s>' + money(it.original_line_price, cur) + '</s>' : '') + '<strong>' + money(it.final_line_price, cur) + '</strong></span>' +
          '<button type="button" class="lp-line__remove" data-lp-remove>Remove</button></div>' +
        '</li>';
      }).join('');

      var empty = cart.item_count === 0;
      el.querySelector('[data-lp-cart-empty]').hidden = !empty;
      el.querySelector('[data-lp-cart-foot]').hidden = empty;
      el.querySelector('[data-lp-cart-total]').textContent = money(cart.total_price, cur);
      var saveRow = el.querySelector('[data-lp-cart-save-row]');
      var saved = cart.original_total_price - cart.total_price;
      saveRow.hidden = !(saved > 0);
      if (saved > 0) el.querySelector('[data-lp-cart-save]').textContent = '−' + money(saved, cur);

      var up = el.querySelector('[data-lp-upsell]');
      if (up) {
        var inCart = cart.items.some(function (it) { return String(it.product_id) === up.dataset.productId; });
        up.hidden = empty || inCart;
      }

      var threshold = +el.dataset.threshold || 0;
      var shipText = el.querySelector('[data-lp-ship-text]');
      if (threshold > 0 && shipText) {
        var left = threshold - cart.total_price;
        var pct = Math.max(0, Math.min(100, cart.total_price / threshold * 100));
        el.querySelector('[data-lp-ship-bar]').style.width = pct + '%';
        if (left > 0) {
          var parts = (el.dataset.freeText || '[amount]').split('[amount]');
          shipText.innerHTML = esc(parts[0]) + '<strong>' + money(left, cur) + '</strong>' + esc(parts[1] || '');
        } else {
          shipText.textContent = el.dataset.freeDone;
        }
      }
      document.dispatchEvent(new CustomEvent('lp:cart:updated', { detail: cart }));
      return cart;
    }
  };
  window.LPCart = Cart;

  function bump() {
    document.querySelectorAll('[data-lp-cart-count]').forEach(function (c) {
      c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
    });
  }

  document.addEventListener('click', function (e) {
    var qb = e.target.closest('[data-lp-line-qty]');
    var rm = e.target.closest('[data-lp-remove]');
    var line = (qb || rm) && (qb || rm).closest('.lp-line');
    if (line) {
      var q = parseInt(line.querySelector('.lp-qty span').textContent, 10);
      var next = rm ? 0 : q + parseInt(qb.dataset.lpLineQty, 10);
      line.classList.add('is-loading');
      Cart.change(line.dataset.key, Math.max(0, next)).catch(function () { line.classList.remove('is-loading'); });
      return;
    }
    var quick = e.target.closest('[data-lp-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.disabled = true;
      var label = quick.innerHTML;
      quick.textContent = 'Adding…';
      Cart.add([{ id: +quick.dataset.lpQuickAdd, quantity: 1 }])
        .then(Cart.afterAdd)
        .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart'); })
        .then(function () { quick.disabled = false; quick.innerHTML = label; });
    }
  });

  /* ---------- Scroll reveal (progressive: content stays visible without JS) ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return; // keep everything visible in the theme editor
    var sel = '.lp-h2, .lp-lead, .lp-card, .lp-step, .lp-pcard, .lp-pet, .lp-review, .lp-split__media, .lp-split .lp-pains, .lp-solution, .lp-compare, .lp-guarantee, .lp-final, .lp-faq';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.closest('.lp-main') || el.getBoundingClientRect().top < window.innerHeight) return; // never hide what is already on screen
      var sibs = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(sel); }) : [];
      el.style.setProperty('--lp-delay', Math.min(sibs.indexOf(el), 5) * 0.08 + 's');
      el.classList.add('lp-reveal');
      io.observe(el);
    });
  }

  /* ---------- Customer videos slider ---------- */
  function initUgc(root) {
    var track = root.querySelector('[data-lp-ugc-track]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    var active = -1;
    function setActive(i) {
      if (i === active) return;
      active = i;
      items.forEach(function (it, k) {
        it.classList.toggle('is-active', k === i);
        var v = it.querySelector('video');
        if (!v) return;
        if (k === i) { v.preload = 'auto'; v.play().catch(function () {}); }
        else { v.pause(); v.muted = true; var b = it.querySelector('[data-lp-ugc-sound]'); if (b) b.textContent = '🔇'; }
      });
    }
    function centerIndex() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
      items.forEach(function (it, k) {
        var d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - mid);
        if (d < bestD) { bestD = d; best = k; }
      });
      return best;
    }
    function go(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      var it = items[i];
      track.scrollTo({ left: it.offsetLeft - (track.clientWidth - it.offsetWidth) / 2, behavior: 'smooth' });
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setActive(centerIndex()); });
    }, { passive: true });
    var prev = root.querySelector('[data-lp-ugc-prev]'), next = root.querySelector('[data-lp-ugc-next]');
    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });
    items.forEach(function (it, k) {
      it.addEventListener('click', function (e) { if (k !== active && !e.target.closest('a')) { e.preventDefault(); go(k); } });
    });
    root.querySelectorAll('[data-lp-ugc-sound]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var v = b.parentElement.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        b.textContent = v.muted ? '🔇' : '🔊';
      });
    });
    // start on the middle card so the slider looks balanced
    var start = Math.floor((items.length - 1) / 2);
    track.scrollLeft = items[start].offsetLeft - (track.clientWidth - items[start].offsetWidth) / 2;
    setActive(centerIndex());
  }

  /* ---------- GIF-style clips: play only while on screen (saves data & battery) ---------- */
  function initClips() {
    var clips = document.querySelectorAll('video[data-lp-clip]:not([data-lp-clip-ready])');
    if (!clips.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { rootMargin: '200px 0px', threshold: 0.15 }) : null;
    clips.forEach(function (v) {
      v.setAttribute('data-lp-clip-ready', '');
      v.muted = true;
      if (reduce) return; // show the poster only
      if (io) io.observe(v); else { v.preload = 'auto'; v.play().catch(function () {}); }
    });
  }

  function init() {
    initReveal();
    initClips();
    document.querySelectorAll('[data-lp-ugc]').forEach(initUgc);
    document.querySelectorAll('[data-lp-ann]').forEach(initAnnouncement);
    document.querySelectorAll('[data-lp-header]').forEach(initSticky);
    var si = document.querySelector('[data-lp-search-input]');
    if (si) initSearch(si);
    Cart.el = document.querySelector('[data-lp-cart]');
    if (Cart.el) Cart.refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Keep the drawer in sync when the page is restored from the back/forward cache
  window.addEventListener('pageshow', function (e) { if (e.persisted && Cart.el) Cart.refresh(); });
})();
